<template>
  <div>
    <template>
      <VueFileAgent
        ref="vueFileAgent"
        v-model="fileRecords"
        :theme="'list'"
        :multiple="true"
        :deletable="true"
        :linkable="false"
        :editable="false"
        :sortable="isSortable"
        :accept="'application/pdf'"
        :help-text="'Ajouter un document'"
        :error-text="{
          type: 'Type de fichier invalide. Seuls les fichiers PDF sont autorisés',
        }"
        :disabled="false"
        @sort="filesOrder()"
        @select="filesSelected($event)"
        @beforedelete="onBeforeDelete($event)"
        @delete="fileDeleted($event)"
      ></VueFileAgent>
    </template>
    <div>
      <b-form-checkbox
        v-model="isSortable"
        class="mt-1"
        :disabled="!fileRecords.length"
        :value="true"
        :unchecked-value="false"
      >
        <div class="ml-2">
          <span v-if="!isSortable">Activer ordre</span>
          <span v-else>Désactiver ordre</span>
        </div>
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import MediaMW from "@/middlewares/Media";

import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import MediaORM from "@/store/orm-axios/models/Media";

var uuid = require("uuid");

export default {
  props: {
    meeting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSortable: false,
      fileRecords: [],
      fileRecordsForUpload: [],
      defaultInvitatioFiles: [
        { name: "Convocation", slug: "invitation" },
        { name: "Documents individuels", slug: "individual_files" },
        { name: "Pouvoir", slug: "pouvoir" },
        { name: "Correspondance", slug: "correspondence" },
        { name: "Ordre du jour", slug: "order" },
        { name: "Annexes", slug: "annexes" },
      ],
      invitationDocsOrder: [],
    };
  },
  created() {
    this.invitationDocsOrder = this.meeting.invitation_docs_order
      ? this.meeting.invitation_docs_order
      : [];

    this.correctDocsPosition();
    this.initFileRecords();
    this.updateInvitationDocsPosition();
    if (this.invitationDocsOrder.length > 0) {
      this.updateDocumentsPosition();
    }
  },
  methods: {
    initFileRecords() {
      this.defaultInvitatioFiles.forEach(doc => {
        if (
          !this.meeting.allowed_modalities.physical &&
          !this.meeting.allowed_modalities.video &&
          doc.slug == "pouvoir"
        ) {
          return;
        }
        if (!this.meeting.allowed_modalities.correspondence && doc.slug == "correspondence") {
          return;
        }
        let position = this.getPosition(doc.slug, "unique_identifier");
        if (!position) {
          position = this.fileRecords.length + 1;
        }
        let defaultRecord = {};
        let file = new File([0], doc.name + ".pdf", {
          type: "application/pdf",
        });
        defaultRecord["file"] = file;
        defaultRecord["delete"] = false;
        defaultRecord["position"] = position;
        defaultRecord["slug"] = doc.slug;
        this.fileRecords.push(defaultRecord);
      });

      var initFileRecordsArray = [];
      const additionalInvitationPrintMedia = MediaORM.query()
        .where("additional_invitation_media_meeting_id", this.meeting.id)
        .get();
      if (additionalInvitationPrintMedia) {
        initFileRecordsArray = additionalInvitationPrintMedia;
      }

      // Create fileRecords for upload zone with existing media
      for (const media of initFileRecordsArray) {
        this.createPdfFileRecord(media);
      }
      // Sort by media position
      this.fileRecords = this.$_.sortBy(this.fileRecords, fileRecord => {
        return fileRecord.position;
      });
    },
    filesOrder() {
      this.fileRecords.forEach((element, index) => {
        element.position = index + 1;
      });
      this.updateInvitationDocsPosition();
      this.updateDocumentsPosition();
    },
    async filesSelected(fileRecordsNewlySelected) {
      let files = [];
      fileRecordsNewlySelected.forEach(fileRecord => {
        // Set unique_identifier to know which file record to update after api pdf check
        let uniqueIdentifier = uuid.v4();
        let index = this.fileRecords.findIndex(record => record == fileRecord);
        this.fileRecords[index]["unique_identifier"] = uniqueIdentifier;
        fileRecord.file["unique_identifier"] = uniqueIdentifier;
        files.push(fileRecord.file);
      });

      let errors = "";
      files.forEach(file => {
        if (file.type != "application/pdf") {
          errors += "\n" + file.name;
        }
      });
      if (errors != "") {
        this.$swal({
          icon: "error",
          title: "Erreur de téléchargement PDF !",
          text: "Certains fichiers n'ont pas été acceptés. Ils doivent être des fichiers PDF.",
          showConfirmButton: false,
          timer: 3500,
        });
        return;
      }
      if (files.length > 0) {
        await MediaMW.MEDIA_CHECK_PDF_FORMAT(
          files,
          "meeting",
          this.meeting.id,
          "additional_invitation"
        )
          .then(res => {
            if (res.response.data.invalidFiles.length > 0) {
              this.$swal({
                icon: "error",
                title: "Erreur de téléchargement PDF !",
                text: this.displayInvalidFiles(res.response.data.invalidFiles),
                showConfirmButton: true,
                timer: 15000,
              });
            }
            if (res.response.data.validFiles.length > 0) {
              res.response.data.validFiles.forEach(file => {
                // Get fileRecord to update based on the unique_identifier
                let index = this.fileRecords.findIndex(
                  record => record.unique_identifier == file.unique_identifier
                );
                this.updatePdfFileRecord(file, index + 1, index);
              });
            }
            this.updateInvitationDocsPosition();
            this.updateDocumentsPosition();
          })
          .catch(() => {
            this.$swal(this.alertError());
          });
      }
    },
    onBeforeDelete(fileRecord) {
      if (fileRecord.delete != false) {
        this.$swal(this.alertQuestion())
          .then(remove => {
            if (remove) {
              this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
          })
          .catch(err => {
            console.log("err", err);
            this.$swal(this.alertError());
          });
      } else {
        this.$swal(this.alertWarning("Ce document ne peut pas être supprimé !"));
      }
    },
    fileDeleted(fileRecord) {
      if (fileRecord.media) {
        this.DELETE_MEDIA(fileRecord.media);
      }
    },
    async DELETE_MEDIA(media) {
      await MediaMW.DELETE(media)
        .then(() => {
          this.removeFromInvitationDocsPosition(media);
          this.correctDocsPosition();
          this.updateDocumentsPosition();
        })
        .catch(() => {
          this.$swal(this.alertError());
        });
    },
    createPdfFileRecord(media, position) {
      let dbPosition = this.getPosition(media.id, "media_id");
      if (!position && !dbPosition) {
        position = this.fileRecords.length + 1;
      } else if (!position) {
        position = dbPosition;
      }
      let mediaName = media.label ? media.label : media.name || media.filename;
      let defaultRecord = {};
      var file = new File([0], mediaName + ".pdf", {
        type: "application/pdf",
      });
      defaultRecord["media"] = media;
      defaultRecord["file"] = file;
      defaultRecord["position"] = position;

      this.fileRecords.push(defaultRecord);
    },
    updatePdfFileRecord(media, position, fileRecordIndex) {
      let dbPosition = this.getPosition(media.id, "media_id");
      if (!position && !dbPosition) {
        position = this.fileRecords.length + 1;
      } else if (!position) {
        position = dbPosition;
      }
      this.fileRecords[fileRecordIndex]["media"] = media;
      this.fileRecords[fileRecordIndex]["position"] = position;
    },
    displayInvalidFiles(invalidFiles) {
      let arrayToShow = [];
      this.$_.each(invalidFiles, file => {
        arrayToShow.push(file.name + " a un format différent de celui A4 ");
      });
      return arrayToShow;
    },
    async updateDocumentsPosition() {
      let self = this;
      await MeetingORM.update({
        where: this.meeting.id,
        data(item) {
          item.invitation_docs_order = self.invitationDocsOrder;
        },
      })
        .then(async m => {
          await MeetingMW.PUT(m, false);
        })
        .catch(err => {
          console.error(err);
          this.$swal(this.alertError());
        });
    },
    updateInvitationDocsPosition() {
      if (this.invitationDocsOrder.length == 0) {
        this.fileRecords.forEach(fileRecord => {
          let object = {};
          if (fileRecord.media) {
            object["media_id"] = fileRecord.media.id;
            object["position"] = fileRecord.position;
          } else {
            object["unique_identifier"] = fileRecord.slug;
            object["position"] = fileRecord.position;
          }
          this.invitationDocsOrder.push(object);
        });
      } else {
        this.fileRecords.forEach(fileRecord => {
          if (fileRecord.media) {
            let itemIndex = this.invitationDocsOrder.findIndex(
              element => element.media_id == fileRecord.media.id
            );
            if (itemIndex != "-1") {
              this.invitationDocsOrder[itemIndex].position = fileRecord.position;
            } else {
              this.invitationDocsOrder.push({
                media_id: fileRecord.media.id,
                position: fileRecord.position,
              });
            }
          } else {
            let itemIndex = this.invitationDocsOrder.findIndex(
              element => element.unique_identifier == fileRecord.slug
            );
            if (itemIndex != "-1") {
              this.invitationDocsOrder[itemIndex].position = fileRecord.position;
            } else {
              this.invitationDocsOrder.push({
                unique_identifier: fileRecord.slug,
                position: fileRecord.position,
              });
            }
          }
        });
      }
    },
    getPosition(value, field) {
      if (this.invitationDocsOrder.length > 0) {
        let itemIndex = this.invitationDocsOrder.findIndex(element => element[field] == value);
        if (itemIndex != "-1") {
          return this.invitationDocsOrder[itemIndex].position;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    removeFromInvitationDocsPosition(media) {
      let itemIndex = this.invitationDocsOrder.findIndex(element => element.media_id == media.id);
      if (itemIndex != "-1") {
        this.invitationDocsOrder.splice(itemIndex, 1);
      }
    },
    correctDocsPosition() {
      let sortedDocsByPosition = this.$_.sortBy(this.invitationDocsOrder, item => {
        return item.position;
      });

      let lastPosition = null;
      let nextPosition = null;
      for (const doc of sortedDocsByPosition) {
        if (lastPosition && doc.position == lastPosition) {
          doc.position = lastPosition + 1;
        } else if (nextPosition && doc.position != nextPosition) {
          doc.position = nextPosition;
        }
        lastPosition = doc.position;
        nextPosition = lastPosition + 1;
      }

      this.invitationDocsOrder = sortedDocsByPosition;
    },
  },
};
</script>
